declare const ENVARS: any;

export const getManagerPortalWebLink = (venueId: string): string =>
  `${ENVARS.VENUE.BASE_URL}/home/venue-details/${venueId}/orders`;
